import { useCallback, useEffect, useMemo, useState } from "react"
import styles from "./Checkbox.module.css"
import { ReactComponent as CheckIcon } from "../assets/images/icons/ic-check.svg"
import { isMobile } from "react-device-detect";

const Checkbox = ({ label = "", value = false, labelPosition = "end", size = "2rem", onChange = null }) => {

  const [_value, setValue] = useState(value)
  const [isCheckHover, setIsCheckHover] = useState(false)

  const checkStyle = useMemo(() => {
    const defaultStyle = {
      cursor: onChange ? "pointer" : "default",
      color: "#FFFFFF",
      width: size,
      height: size,
      backgroundColor: "#FFFFFF"
    }
    const filled = {
      cursor: onChange ? "pointer" : "default",
      color: "#FFFFFF",
      width: size,
      height: size,
      backgroundColor: "var(--sf-light-green)"
    }
    const hovered = {
      cursor: onChange ? "pointer" : "default",
      color: "var(--sf-light-green)",
      width: size,
      height: size,
      backgroundColor: "rgba(var(--sf-light-green-rgb), 0.2)",
    }
    if (_value) {
      return filled
    }
    return isCheckHover && !isMobile ? hovered : defaultStyle

  }, [isCheckHover, _value])

  useEffect(() => setValue(value), [value])

  const handleChange = useCallback((e) => {
    if (onChange === null) return

    setValue(!_value)

    if (onChange) {
      onChange(!_value)
    }
  }, [_value, onChange])


  return (
    <div className={styles.container}>
      {
        label && labelPosition === "start" &&
        <div className={styles.label}>{label}</div>
      }
      {
        _value === false && isCheckHover === false &&
        <div className={styles.check} style={checkStyle}
          onMouseEnter={() => setIsCheckHover(true)}
          onMouseLeave={() => setIsCheckHover(false)}
          onClick={handleChange}
        />
      }
      {
        _value === false && isCheckHover === true &&
        <CheckIcon className={styles.check} style={checkStyle}
          onMouseEnter={() => setIsCheckHover(true)}
          onMouseLeave={() => setIsCheckHover(false)}
          onClick={handleChange} />
      }
      {
        _value === true &&
        <CheckIcon className={styles.check} style={checkStyle}
          onMouseEnter={() => setIsCheckHover(true)}
          onMouseLeave={() => setIsCheckHover(false)}
          onClick={handleChange} />
      }
      {
        label && labelPosition === "end" &&
        <div className={styles.label}>{label}</div>
      }
    </div>
  )
}

export default Checkbox
